module.exports = __webpack_public_path__ + "img/forlderIcon.19a351aa.svg";